import React from 'react';
import { Footer as FooterBase } from 'shared';

export const Footer = () => {
  return <FooterBase />;
};
